import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { ReactFlow, Background, Controls, MiniMap, BackgroundVariant, } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { WorkspaceNode } from "./nodes/WorkspaceNode";
import { ProjectNode } from "./nodes/ProjectNode";
import { TaskNode } from "./nodes/TaskNode";
import { NotificationNode } from "./nodes/NotificationNode";
// Register custom node types with proper typing
const nodeTypes = {
    workspace: WorkspaceNode,
    project: ProjectNode,
    task: TaskNode,
    notification: NotificationNode,
};
export function FlowCanvas({ nodes, edges, onNodeClick, onNodesChange, onEdgesChange, showMiniMap = false, className = "", }) {
    // Handle node click with proper typing
    const handleNodeClick = useCallback((event, node) => {
        if (onNodeClick) {
            onNodeClick(event, node);
        }
    }, [onNodeClick]);
    // Handle initialization to center on workspace node
    const handleInit = useCallback((reactFlowInstance) => {
        // Find the workspace node (should be the first/root node)
        const workspaceNode = nodes.find((node) => node.type === "workspace");
        if (workspaceNode) {
            // Center view on the workspace node with some offset to show hierarchy below
            reactFlowInstance.setCenter(workspaceNode.position.x + 156, // Half of workspace width (312/2)
            workspaceNode.position.y + 200, // Offset down to show workspace at top
            { zoom: 1.56, duration: 0 });
        }
        else {
            // Fallback to fitView if no workspace node found
            reactFlowInstance.fitView({ padding: 0.15, minZoom: 1.3, maxZoom: 2.6, duration: 0 });
        }
    }, [nodes]);
    return (_jsx("div", { className: `flow-canvas ${className}`, style: { width: "100%", height: "100%" }, children: _jsxs(ReactFlow, { nodes: nodes, edges: edges, nodeTypes: nodeTypes, onNodeClick: handleNodeClick, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, onInit: handleInit, 
            // Pan and zoom configuration
            panOnScroll: true, panOnDrag: true, zoomOnScroll: true, zoomOnPinch: true, zoomOnDoubleClick: true, 
            // Node dragging
            nodesDraggable: true, nodesConnectable: false, elementsSelectable: true, 
            // Minimum and maximum zoom
            minZoom: 0.2, maxZoom: 4.0, 
            // Default viewport - will be overridden by onInit
            defaultViewport: { x: 0, y: 0, zoom: 1.56 }, 
            // Styling
            className: "flow-canvas-inner", children: [_jsx(Background, { color: "var(--flow-node-border, #e5e5e5)", gap: 16, size: 1, variant: BackgroundVariant.Dots }), _jsx(Controls, { showZoom: true, showInteractive: false, position: "bottom-right" }), showMiniMap && (_jsx(MiniMap, { nodeColor: (node) => {
                        const nodeData = node.data;
                        switch (nodeData.type) {
                            case "workspace":
                                return "#000";
                            case "project":
                                return "#666";
                            case "task":
                                return "#999";
                            case "notification":
                                return "#bdbdbd";
                            default:
                                return "#e5e5e5";
                        }
                    }, maskColor: "rgba(0, 0, 0, 0.1)", position: "bottom-left", style: {
                        background: "var(--flow-node-bg, #fff)",
                        border: "1px solid var(--flow-node-border, #e5e5e5)",
                    } }))] }) }));
}
